import { useState } from "react";
import { useCreateStripeAdminAxiosInstance } from "../../Auth/useCreateStripeAdminAxiosInstance.ts";
import { StripeOrderDTO } from "../../Stripe/StripeOrderDTO.ts";

export function useCancelSubscriptionStripeOrder() {
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();

  const [loading, setLoading] = useState(false);
  const cancelSubscriptionStripeOrder = async (
    order: StripeOrderDTO,
  ): Promise<void> => {
    const axiosInstance = createAxiosInstance();
    try {
      setLoading(true);
      await axiosInstance.post(`/payment-intent/cancel-subscription/`, {
        order,
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    cancelSubscriptionStripeOrder: cancelSubscriptionStripeOrder,
    loading,
  };
}
